module.exports = __webpack_public_path__ + "Roboto-ThinItalic.11b5cc9584f2c007a229.ttf";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-ThinItalic.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-ThinItalic.ttf
// module chunks = 34